import React, { useState, createContext } from 'react'

interface IScreenLocked {
  children: React.ReactNode
}
export const ScreenLockContext = createContext({
  screenScrollingLocked: false,
  /* eslint-disable @typescript-eslint/no-empty-function */
  updateLockedScreen: () => {}
})

export function ScreenLockProvider({ children }: IScreenLocked) {
  const [screenScrollingLocked, setScreenScrollingLocked] = useState(false)

  const updateLockedScreen = () => {
    setScreenScrollingLocked((t) => !t)
  }

  return (
    <ScreenLockContext.Provider
      value={{
        screenScrollingLocked,
        updateLockedScreen
      }}
    >
      {children}
    </ScreenLockContext.Provider>
  )
}
